import { IApplicationState, TBoardId } from '../../../../types/types';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardMetaStartDateSetCount = (
    state: IApplicationState,
    boardId: TBoardId
): number => {
    const userBoardMeta = getBoardUserMeta(state, boardId);
    return userBoardMeta && userBoardMeta.startDateSetCount || 0;
};
